import { Component, Input, OnInit } from '@angular/core';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
import { NzNotificationService } from 'ng-zorro-antd/notification';

import { FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { NzModalService } from 'ng-zorro-antd/modal';
import { Observable, Observer } from 'rxjs';
@Component({
  selector: 'app-drawer',
  templateUrl: './drawer.component.html',
  styleUrls: ['./drawer.component.scss']
})
export class DrawerComponent implements OnInit {
  date = null;
  listOfOption: string[] = [];
  listOfSelectedValue = ['a10', 'c12'];
  validateForm: FormGroup;
  @Input() value = '';
  visible = false;
  constructor(private drawerRef: NzDrawerRef<string>,
              private notification: NzNotificationService,
              private fb: FormBuilder,
              private modalService: NzModalService,
              ) {
                this.validateForm = this.fb.group({
                userName: ['', [Validators.required], [this.userNameAsyncValidator]],
                email: ['', [Validators.email, Validators.required]],
                password: ['', [Validators.required]],
                confirm: ['', [this.confirmValidator]],
                comment: ['', [Validators.required]],
                datetime: [''],
                select: [this.listOfSelectedValue],
                });
               }

  ngOnInit() {
    const children: string[] = [];
    for (let i = 10; i < 36; i++) {
      children.push(`${i.toString(36)}${i}`);
    }
    this.listOfOption = children;
  }
  submitForm(value: { userName: string; email: string; password: string; confirm: string; comment: string }): void {
    for (const key in this.validateForm.controls) {
      this.validateForm.controls[key].markAsDirty();
      this.validateForm.controls[key].updateValueAndValidity();
    }
    this.notification.blank('Thêm người dùng thành công', 'Người dùng đã được thêm vào hệ thống!').onClick.subscribe(() => {
    });
  }
  resetForm(e: MouseEvent): void {
    e.preventDefault();
    this.validateForm.reset();
    for (const key in this.validateForm.controls) {
      this.validateForm.controls[key].markAsPristine();
      this.validateForm.controls[key].updateValueAndValidity();
    }
  }
  validateConfirmPassword(): void {
    setTimeout(() => this.validateForm.controls.confirm.updateValueAndValidity());
  }

  userNameAsyncValidator = (control: FormControl) =>
    new Observable((observer: Observer<ValidationErrors | null>) => {
      setTimeout(() => {
        if (control.value === 'JasonWood') {
          // you have to return `{error: true}` to mark it as an error event
          observer.next({ error: true, duplicated: true });
        } else {
          observer.next(null);
        }
        observer.complete();
      }, 1000);
    });

  confirmValidator = (control: FormControl): { [s: string]: boolean } => {
    if (!control.value) {
      return { error: true, required: true };
    } else if (control.value !== this.validateForm.controls.password.value) {
      return { confirm: true, error: true };
    }
    return {};
  };
  onsubmit(): void {
    this.drawerRef.close(this.value);
  }
  close(e: MouseEvent) {
    e.preventDefault();
    this.validateForm.reset();
    this.drawerRef.close(this.value);
  }
  onChange(result: Date[]): void {
  }
}
